import { Head } from "@inertiajs/react"
import { useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import DocumentForm from "./_form"

interface CaseRecord {
  id: number
  case_number: string
  display_name: string
}

interface DocumentType {
  id: number
  name: string
}

interface Props {
  case_record: CaseRecord
  document_types: DocumentType[]
  errors?: Record<string, string[]>
}

export default function New({ case_record, document_types, errors }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Cases", href: "/cases" },
    {
      title: case_record.display_name || case_record.case_number,
      href: `/cases/${case_record.id}`,
    },
    { title: "Documents", href: `/cases/${case_record.id}/documents` },
    { title: "New", href: `/cases/${case_record.id}/documents/new` },
  ]

  const { data, setData, post, processing, transform } = useForm({
    files: null as File[] | null,
    bg_document_type_id: null as number | null,
    title: "",
    notes: "",
    document_date: new Date().toISOString().slice(0, 16),
    significant: 0,
    on_reports: 0,
    is_public: 0,
  })

  transform((data) => ({ case_document: data }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(`/cases/${case_record.id}/documents`, { forceFormData: true })
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`New Document - ${case_record.case_number}`} />

      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">Upload Documents</h1>
        <DocumentForm
          caseId={case_record.id}
          data={data}
          setData={setData}
          errors={errors}
          processing={processing}
          onSubmit={handleSubmit}
          submitLabel="Upload"
          documentTypes={document_types}
          isNew
        />
      </div>
    </AppLayout>
  )
}
